<template>
	<div class="alltitlStyle">
		<h2 class="modTitlte">
			<span v-html="titleObj.title"></span>
		</h2>
		<p v-if="titleObj.p" v-html="titleObj.p"></p>
	</div>
</template>
<script>
export default {
	name: "TitleAssembly",
	props: {
		titleObj:{
      type:Object,
      default:{}
    }
	},
	components: {},
	data() {
		return {};
	},
	created() {},
	mounted() {},
	methods: {},
};
</script>
<style lang="scss" scoped>
.alltitlStyle{
 margin:80px 30px 50px;
 p{
   text-align:center;
 }
}
.modTitlte {
	font-size: 30px;
	text-align: center;
	margin: 56px 0 15px 0;
  z-index:99;
  font-weight:bold;
  span{
    display: inline-block;
    position: relative;
    z-index:100;
  }
}
.modTitlte span::after{
  content:'';
  width:100%;
  left:0;
  right:0;
  height:10px;
  border-radius: 10px;
  background:#FF6817;
  opacity: 0.2;
  position: absolute;
  display: inline-block;
  z-index:-1;
  bottom:3px;
}
</style>
